import React from 'react'
import './Header.css'




//icons
import SearchIcon from '@material-ui/icons/Search';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import { Link } from 'react-router-dom';
import { useStateValue } from './StateProvider';



function Header() {


    const [{ basket }, dispatch] = useStateValue();
    const totalItems = basket.reduce((acc, curr) => curr.qty + acc, 0);
    return (
        <div className="header navbar navbar-expand row m-0 py-3">
            <Link to="/" style={{ textDecoration: 'none' }}>
                <div
                    className=" header__logo navbar-brand ">
                    VSM electronics
                    </div>
            </Link>

            <button class="navbar-toggler colo" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>


            <div class="collapse navbar-collapse" id="navbarTogglerDemo01">



                <div className="header__search ">
                    <input type="text" className="header__searchInp " />
                    <SearchIcon className="header__searchIcon" />

                </div>

                <div className="header__nav ">
                    <div className="header__option">
                        <span className="header__lineOne">Hello, Guest</span>
                        <Link to="/login" style={{ textDecoration: 'none' }}>
                            <span className="header__lineTwo"> Login </span>
                        </Link>
                    </div>
                    <div className="header__option nav-item">
                        <span className="header__lineOne">Returns</span>
                        <span className="header__lineTwo"> & Orders </span>
                    </div>

                    <Link to="/checkout" style={{ textDecoration: 'none' }}>
                        <div className="header__basket nav-item">
                            <ShoppingBasketIcon />
                            <span className="header__lineTwo header__basketCount">{totalItems}</span>

                        </div>
                    </Link>

                </div>

            </div>

        </div>
    )
}

export default Header
